module.exports = __webpack_public_path__ + "static/wellhealth-logo-white-60fc102725453222e33ea01e6482f2ff.png";